import Swiper, { Navigation, Pagination, EffectFade } from "swiper";
Swiper.use([Navigation, Pagination, EffectFade]);
import "swiper/css";
import "swiper/css/effect-fade";

// Logos - Homepage
new Swiper(".swiper.c-logos", {
  loop: true,
  slidesPerView: 2,
  spaceBetween: 0,
  breakpoints: {
    768: {
      slidesPerView: 4,
    },
    992: {
      slidesPerView: 6,
    },
  },
});

// Blogs - Homepage
new Swiper(".c-blogslider", {
  slidesPerView: 1,
  spaceBetween: 30,
  loop: true,
  breakpoints: {
    768: {
      slidesPerView: 2,
      spaceBetween: 30,
    },
    992: {
      slidesPerView: 3,
      spaceBetween: 60,
      loop: false,
    },
  },
});

// Slider (image + content) - Homepage
new Swiper(".c-slider__slides", {
  slidesPerView: 1,
  speed: 500,
  effect: "fade",
  loop: true,
  fadeEffect: {
    crossFade: true,
  },
  pagination: {
    el: ".c-slider__pagination",
    clickable: true,
  },
  navigation: {
    nextEl: ".c-slider__arrow.next",
    prevEl: ".c-slider__arrow.prev",
  },
});

// Imageslider - productdetail
new Swiper(".o-imageslider__images", {
  slidesPerView: 1,
  speed: 500,
  effect: "fade",
  loop: true,
  fadeEffect: {
    crossFade: true,
  },
  pagination: {
    el: ".o-imageslider__pagination",
    clickable: true,
  },
  navigation: {
    nextEl: ".o-imageslider__nav.next",
    prevEl: ".o-imageslider__nav.prev",
  },
});

// Gerelateerde product - productdetail
new Swiper(".c-relatedproducts__slides", {
  slidesPerView: 1,
  loop: true,
  breakpoints: {
    768: {
      slidesPerView: 2,
    },
    992: {
      slidesPerView: 3,
    },
    1200: {
      slidesPerView: 4,
    },
  },
  navigation: {
    nextEl: ".c-relatedproducts__nav.next",
    prevEl: ".c-relatedproducts__nav.prev",
  },
});

// Producttabs
const sections = document.querySelectorAll("#producttabs div[id]");
window.addEventListener("scroll", navHighlighter);

function navHighlighter() {
  let scrollY = window.pageYOffset;

  sections.forEach((current) => {
    const sectionHeight = current.offsetHeight;

    const sectionTop =
      current.getBoundingClientRect().top + window.pageYOffset - 100;
    var sectionId = current.id;

    if (scrollY > sectionTop && scrollY <= sectionTop + sectionHeight) {
      document
        .querySelector(".c-producttabs a[href*=" + sectionId + "]")
        .classList.add("active");
    } else {
      document
        .querySelector(".c-producttabs a[href*=" + sectionId + "]")
        .classList.remove("active");
    }
  });
}

var menuItems = document.querySelectorAll(".menu span");
var submenus = document.querySelectorAll(".submenu");

for (let i = 0; i < menuItems.length; i++) {
  menuItems[i].addEventListener("click", function (e) {
    if (menuItems[i].classList.value === "goback") {
      menuItems[i].parentElement.classList.remove("active");
      e.stopPropagation();
    } else {
      menuItems[i].querySelector(".submenu").classList.add("active");
    }
  });
}

document
  .querySelector(".navigation__button")
  .addEventListener("click", function () {
    document.querySelector("body").classList.toggle("fixed");

    if (!document.querySelector("body").classList.contains("fixed")) {
      for (let i = 0; i < submenus.length; i++) {
        submenus[i].classList.remove("active");
      }
    }
  });

if (document.querySelector(".btn.showpopup")) {
  document
    .querySelector(".btn.showpopup")
    .addEventListener("click", function () {
      document.querySelector(".c-popup").classList.add("active");
      document.querySelector("body").classList.add("fixed");
    });
}

if (document.querySelector(".btn.hidepopup")) {
  document
    .querySelector(".btn.hidepopup")
    .addEventListener("click", function () {
      document.querySelector(".c-popup").classList.remove("active");
      document.querySelector("body").classList.remove("fixed");
    });
}

var floatingInputs = document.querySelectorAll(".form-group.floating");

for (let i = 0; i < floatingInputs.length; i++) {
  floatingInputs[i].addEventListener("click", function () {
    this.classList.add("active");
  });
}

document.addEventListener("scroll", function () {
  if (document.querySelector(".c-producttabs")) {
    var producttabs = document.querySelector(".c-producttabs");
    var topProducttabs = producttabs.getBoundingClientRect().top;
    var productheader = document.querySelector(".c-productheader");

    if (topProducttabs > 64) {
      productheader.classList.remove("active");
      producttabs.classList.remove("active");
    } else {
      productheader.classList.add("active");
      producttabs.classList.add("active");
    }
  }
});

var productAccordions = document.querySelectorAll(".c-productattributes h2");

if (productAccordions) {
  for (let i = 0; i < productAccordions.length; i++) {
    productAccordions[i].addEventListener("click", function () {
      this.classList.toggle("active");
    });
  }
}

document
  .querySelector(".navigation .header__currentcart__link")
  .addEventListener("click", function () {
    document
      .querySelector(".navigation .header__currentcart__dropdown")
      .classList.add("active");
  });

document
  .querySelector(".navigation .header__currentcart__goback")
  .addEventListener("click", function () {
    document
      .querySelector(".navigation .header__currentcart__dropdown")
      .classList.remove("active");
  });
